//persian number to English Digits
const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));




const numeric = {
    p2e,

};

export default numeric;